import { jwtDecode } from 'jwt-decode';
import { OAuthConfig } from '../config/config.model';

export type AccessDeniedReason = 'no-token' | 'invalid-token' | 'wrong-organization' | 'missing-role';

export type AccessResult =
  | { allowed: true; roles: string[]; organizations: string[]; username: string }
  | { allowed: false; reason: AccessDeniedReason };

interface DecodedToken {
  realm_access?: { roles: string[] };
  organization?: string[];
  preferred_username?: string;
}

export function evaluateAccess(accessToken: string | null | undefined, oauth: OAuthConfig): AccessResult {
  if (!accessToken) {
    return { allowed: false, reason: 'no-token' };
  }

  let decoded: DecodedToken;
  try {
    decoded = jwtDecode<DecodedToken>(accessToken);
  } catch {
    return { allowed: false, reason: 'invalid-token' };
  }

  const roles = decoded.realm_access?.roles ?? [];
  const organizations = decoded.organization ?? [];
  const username = decoded.preferred_username ?? '';

  const bypassesTenant = oauth.devBypassRole ? roles.includes(oauth.devBypassRole) : false;

  if (!bypassesTenant && !organizations.includes(oauth.tenantOrganizationAlias)) {
    return { allowed: false, reason: 'wrong-organization' };
  }

  const hasAllowedRole = oauth.allowedRoles.some((r) => roles.includes(r));
  if (!bypassesTenant && !hasAllowedRole) {
    return { allowed: false, reason: 'missing-role' };
  }

  return { allowed: true, roles, organizations, username };
}
